const BannerConfig = {
  DEFAULT_BANNER_WIDTH: 300,
  DEFAULT_BANNER_HEIGHT: 250,
  SPECIAL_WIDTHS: [336, 320, 160, 120]
};

export default BannerConfig;
